import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme/myPalette'

export const TopBlockWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 24px 0;
`

export const BottomBlockWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: stretch;
`

export const FullWidthBlockWrapper = styled.div`
  margin-top: 16px;
`

export const Chip = styled.div`
  border-radius: 8px;
  padding: 4px 16px;
  font-size: 12px;
  font-weight: 500;
  color: ${myPalette.black.main};
  background: ${myPalette.white.main};
  display: inline;
`
export const BlockTariff = styled.div`
  display: flex;
`

export const Typography = styled.div`
  color: ${myPalette.white.main};
`

export const Block = styled.div`
  flex-direction: column;
  justify-content: center;
  padding: 16px;
  display: flex;
  background: ${myPalette.white.main};
  font-size: 18px;
  border-radius: 12px;
  flex: 1;
`
export const BlockTitle = styled.div`
  font-size: 14px;
  color: ${myPalette.mutedText.main};
`
export const BlockDescription = styled.div`
  font-size: 18px;
  font-weight: 500;
`
